import { Controller } from '@hotwired/stimulus'
import Swiper from 'swiper'

export default class extends Controller {
  connect() {
    this.slider = new Swiper(this.element, {
      loop: true,
      slidesPerView: 1,
      centeredSlides: true,
      effect: 'fade',
      speed: 2000,
      autoplay: {
        delay: 1000,
      },
      allowTouchMove: false,
    })

    this.slider.autoplay.stop()
    this.startSlider = () => {
      this.timerId = setTimeout(() => this.slider.autoplay.start(), 2000)
    }
    window.addEventListener('DOMContentLoaded', this.startSlider)
  }

  disconnect() {
    if (this.timerId) {
      window.clearTimeout(this.timerId)
    }
    this.timerId = null
    window.removeEventListener('DOMContentLoaded', this.startSlider)
    this.startSlider = null

    this.slider.destroy()
    this.slider = undefined
  }
}
